// @flow
import * as constants from './constants';

import { createAction } from 'redux-actions';

export const loadCookies = createAction(constants.LOAD_COOKIES);
export const cookiesLoaded = createAction(constants.COOKIES_LOADED);
export const setCookie = createAction(constants.SET_COOKIE);
export const cookieSet = createAction(constants.COOKIE_SET);



// WEBPACK FOOTER //
// ./src/core/state/cookies/actions.js